import { useCallback, useState } from 'react';
import { useNavigate } from "react-router";
import NotificationsHeader from "../NotificationsHeader";
import NotificationsList, { getPaginatedNotifications } from "../NotificationsList";
import { useNotifications } from '@iscr/notifications/hooks/useNotifications';
import { useNotificationToasts } from '@iscr/notifications/hooks/useNotificationToasts';
import { useDynamicNotifications } from '@iscr/notifications-plugins/useDynamicNotifications';
import { useRegisterNotificationPlugins } from '@iscr/notifications-plugins/useRegisterNotificationPlugins';

const PAGE_SIZE = 7;

const NotificationsListApp = ({
    autoFocus = false,
    onClose,
}) => {
    const navigate = useNavigate();
    const [hasUnreadButton, setHasUnreadButton] = useState(false);

    const {
        notifications,
        notificationsLoading,
        setNotificationRead,
        setNotificationsRead,
        getPlugin
    } = useNotifications();
    useNotificationToasts();
    useRegisterNotificationPlugins();
    useDynamicNotifications();

    const handleOnClose = useCallback(() => {
        if (!hasUnreadButton) {
            const paginatedNotifications = getPaginatedNotifications(notifications, 1, PAGE_SIZE);
            const notification_ids =
                paginatedNotifications
                    .filter(n => !n.read && !n.overrides?.persistent)
                    .map(n => n.notification_id);
            setNotificationsRead(notification_ids, true);
        }
        onClose?.();
    }, [
        notifications,
        setNotificationsRead,
        onClose,
        hasUnreadButton,
    ]);

    const handlePageChange = useCallback(({ previousPageNotifications }) => {
        if (!hasUnreadButton) {
            const notification_ids =
                previousPageNotifications
                    .filter(n => !n.read && !n.overrides?.persistent)
                    .map(n => n.notification_id);
            setNotificationsRead(notification_ids, true);
        }
    }, [setNotificationsRead, hasUnreadButton]);

    const handleNotificationClick = (notification) => {
        setNotificationRead(notification.notification_id, true);

        if (notification.link) {
            navigate(notification.link, notification.link_options || undefined);
            onClose?.();
        }
    };

    const allCount = notifications.length;
    const newCount = notifications.filter(n => !n.read).length;

    return (
        <>
            <NotificationsHeader
                allCount={allCount}
                newCount={newCount}
                onClose={handleOnClose}
            />
            <NotificationsList
                notifications={notifications}
                loading={notificationsLoading}
                setNotificationRead={setNotificationRead}
                autoFocus={autoFocus}
                getPlugin={getPlugin}
                onNotificationClick={handleNotificationClick}
                onPageChange={handlePageChange}
                onClose={handleOnClose}
                pageSize={PAGE_SIZE}
                hasUnreadButton={hasUnreadButton}
            />
        </>
    );
};

export default NotificationsListApp;
